import {UI} from "../../../../../../stem-core/src/ui/UIBase.js";
import {StyleSheet} from "../../../../../../stem-core/src/ui/Style.js";

import {PaymentMethodIcon} from "./PaymentMethodIcon.jsx";
import {Messages} from "../../../../../Messages.js";
import {registerStyle} from "../../../../../../stem-core/src/ui/style/Theme.js";
import {styleRule} from "../../../../../../stem-core/src/decorators/Style.js";
import {MessageElement} from "../../../../../widget/ui/MessageElement.jsx";
import {iFrameMerchantService} from "blinkpay/services/IframeMerchantService.js";


class ActiveCardInfoStyle extends StyleSheet {
    @styleRule
    container = {
        display: "flex",
        alignItems: "center",
    };

    @styleRule
    usingCardText = {
        display: "inline-block",
        alignSelf: "flex-end",
    };

    @styleRule
    cardIcon = {
        display: "inline-block",
        marginRight: 12,
    };
}

@registerStyle(ActiveCardInfoStyle)
export class ActiveCardInfo extends UI.Element {
    getDefaultOptions() {
        return {
            hideIcon: false,
            card: null, // TODO @cleanup rename to paymentMethod
        }
    }

    render() {
        const {styleSheet} = this;
        const {card, hideIcon} = this.options;

        if (!card) {
            return null;
        }

        const brand = card.getBrand();
        const lastDigits = iFrameMerchantService.isCDSPaymentMethod() ? card.cardNumber?.slice(-4) : card.getLastDigits(); // TODO @cleanup should only be card.getLastDigits

        if (!lastDigits) {
            // TODO @cleanup @branch ensure no longer needed
            return null; // This is only a CDS
        }

        return [
            !hideIcon && <PaymentMethodIcon className={styleSheet.cardIcon} brand={brand} size={15}/>,
            <MessageElement className={styleSheet.usingCardText} message={Messages.usingCardSubscribe(brand, lastDigits)} />
        ]
    }

    isValid() {
        // TODO @input @cleanup @branch WTF is this? Remove
        return true;
    }
}
